module.exports = __webpack_public_path__ + "img/features_fraud_insurance_mobile.b8f37e64.png";